import moment from "moment/moment"
import * as yup from 'yup';
import { sto } from "../Context/InshData";
import i18next from "i18next";

export const taswyaValidateSchema = yup.object().shape({
  acc: yup.string().required(() => i18next.t("forms:select-account-required")),
  safe: yup.string().required(() => i18next.t("forms:select-store-required")),
})


export const secondFiltersOptions=[
    {id: 1, name:'items_except_negative'},
    {id: 2, name:'items_except_zero'},
    {id: 3, name:'items_except_negative_and_zero'},
    {id: 4, name:'negative-items-only'},
    {id: 5, name:'zero-items-only'},
    {id: 6, name:'negative-and-zero-items-only'}
]
export const dfaultfilters={
  group:{id:0, name:''},
  filter:{id:0, name:''},
  safe: -1,
  branch:sto.branchi,
  all: false,
  empty: true,
}
export const defaultTaswyaData ={
    no: '',
    date: new moment(new Date()).format('YYYY-MM-DD'),
    safe: {},
    center: -1,
    refno:'',
    notes: '',
    res_id: '',
    acc:{id:'', name:'',},
    branch: sto.branchi,
    rows:[],
}

export function isEmptyFilters(filters){
    return (filters.group.id === 0 && filters.filter.id === 0 && !filters.all) 
}

export function getReFormatingGtys(data){

    const newData = data.map((row, i)=> {
            return {...row, id:i,
                 item:{id: row.currency_from, symbol: row.Name_Item}, 
                val2:0, 
            diff: (0 - row.Qtys),} 
        })
    return newData
}


export function formatTaswya(data){

    var clone = Object.assign({}, data);
    delete clone.rows; 
    const taswya ={...clone, 
        acc: data.acc.id, 
        center: data.center.id? data.center.id : '-1',
        safe: data.safe.id,
        branch: sto.branchi,
    }

    const _Data = data.rows.map(r=>{
        return {item: r.currency_from,
                unit: r.unit,
                avg_price: r.avgCost,
                val1: r.Qtys,
                val2: r.val2,
                diff:r.val2 - r.Qtys,}
    })
    return { taswya:taswya, _Data: _Data }
}